import { LicenceRoleType } from "@enums/licence-role-type.enum";
import { ProviderType } from '@enums/provider-type.enum';

export class AuthUser {
    name: string;
    role: LicenceRoleType;
    provider: ProviderType;
    language: string;

    constructor(name: string, role: LicenceRoleType, provider: ProviderType, language: string) {
        this.name = name;
        this.role = role;
        this.provider = provider;
        this.language = language;
    }

    public get isRestricted(): boolean {
        return (
            this.role === LicenceRoleType.man
        );
    }

    public get isUsersManager(): boolean {
        return (
            this.role === LicenceRoleType.admin ||
            this.isLicencesManager
        );
    }

    public get isLicencesManager(): boolean {
        return (
            this.role === LicenceRoleType.bzd ||
            this.role === LicenceRoleType.bko ||
            this.role === LicenceRoleType.servicing
        );
    }
}
